<template>
  <footer class="footer" :class="{ 'footer-abs': !currentUser }">
    <div class="encaixat has-text-centered">
      <router-link to="/" class="has-text-white">
      Suport d'Arrel
      </router-link>
    </div>
    <div class="has-text-centered has-text-white has-margin-bottom-2">
      Suport a les iniciatives que ofereixen serveis i productes de manera solidària durant el Covid-19
    </div>
    <div class="has-text-centered has-text-white has-margin-bottom-2">
      <a href="http://nuriasocial.org/xesgarrotxa/" target="_blank">
        <img src="@/assets/images/logo-xes-garrotxa-1.png" width="240" height="100" class="has-background-white" />            
      </a>
      <a href="https://webcoop.cat" target="_blank" class="webcoop">
        <img src="@/assets/images/webcoop.png" width="240" height="100" class="has-background-white" />            
      </a>
    </div>
    <div class="container line">      
      <router-link class="footer-link" to="/">INICI</router-link>
      <router-link class="footer-link" to="/ajuda">COM FUNCIONA?</router-link>
      <router-link class="footer-link" to="/login">REGISTRA'T</router-link>
      
      <span class="footer-span">IMPULSAT PER</span>
      <a target="_blank" class="footer-link" href="http://nuriasocial.org/xesgarrotxa/">XES GARROTXA</a>
      <a target="_blank" class="footer-link" href="https://webcoop.cat">WEBCOOP</a>      
    </div>

  </footer>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["currentUser", "userProfile"])
  },
  mounted() {
  }
};
</script>
<style scoped>
.footer{  
  background-color: #f14668;
  background-color: #444444;
  padding-bottom: 1.0rem;
  margin-top: 12px;
}


.encaixat{
  text-transform: uppercase;
font-weight: bold;
color: #49C4AF;
color: #fff;
font-family: 'Varela Round';
font-weight: bold;
font-size: 24px;
margin-bottom: 2rem;
}
.line{
  border-top:1px solid #595959;
  text-align: right;
}
.footer-link{
  color: #fff;  
  margin-left: 40px;
  font-size: 14px;
  outline: none;
  display: block;
  padding: 8px 0;
}
.footer-span{
  color: #a3a3a3;
  margin-left: 40px;
  font-size: 14px;
  outline: none;
}
.footer-link:hover{
  color: #FF0059;
}
.webcoop img{  
  padding: 30px;
  background: transparent;
}
@media screen and (min-width: 742px) {
  .webcoop img{
      margin-left: 50px;
  }
  .footer-link{
    display: inline-block;
    padding: 8px 0 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue